import { html, ifDefined } from 'omni-ui';
import { mergeClass, Om2FormFieldBase, SHARED_FIELD } from './common/base.js';

/**
 * Render a multiline string input (textarea)
 */
export class Om2FormFieldMultilineString extends Om2FormFieldBase {
  static metadata = {
    config: {
      label: 'Textarea Input',
      overrides: {
        type: 'string',
        multiline: true,
      },
      fields: {
        id: SHARED_FIELD,
        title: SHARED_FIELD,
        tooltip: SHARED_FIELD,
        class: SHARED_FIELD,
        default: SHARED_FIELD,
        placeholder: SHARED_FIELD,
        rows: {
          title: 'Rows',
          type: 'number',
          min: 1,
          multipleOf: 1,
        },
        required: SHARED_FIELD,
        disabled: SHARED_FIELD,
        readonly: SHARED_FIELD,
        'omni-assist': {
          title: 'Omni Assist',
          type: 'string',
          enum: ['none', 'autofill'],
          default: 'none',
        },
        'omni-assist-config': {
          title: 'Omni Assist Config',
          type: 'object',
          default: { type: '', prompt: '' },
          tooltip:
            'Config must be a JSON object with "type" and "prompt" keys defined. The type is the embedding type in omni assist, and the prompt is a prompt template string that will be expanded and used for the openai prompt. Variables in the template are delimited with double curly braces {{ }} and can refer to the client name {{ client_name }} or form fields on the page using the CSS selector syntax {{ [name=\'field_id\'] }}. If multiple elements match on the page, the closest will be used. The template will be replaced with the value property of the element, or if undefined the innerText property. The current field would then be auto-filled with the openai completion text.',
          formModal: {
            fullWidth: true,
            hideIf: { id: 'omni-assist', op: '===', value: 'none' },
          },
        },
      },
    },
  };

  render() {
    const { schema } = this;
    return html`<textarea
      class=${mergeClass('textarea', schema.class)}
      .name="${this.key}"
      .value=${this.data ?? schema.default ?? ''}
      placeholder=${ifDefined(schema.placeholder)}
      ?required=${schema.required}
      ?disabled=${schema.disabled || this._isHidden()}
      ?readonly=${schema.readonly || this.context?.readonly}
      rows=${ifDefined(schema.rows)}
      @focus=${() => {
        this.dispatchNewEvent('om2-field-focus');
      }}
      @blur=${() => {
        this.dispatchNewEvent('om2-field-blur');
      }}
    ></textarea>`;
  }
}

Om2FormFieldMultilineString.register('string-multiline');
